import { render, staticRenderFns } from "./studyMsg.vue?vue&type=template&id=642bdf24&scoped=true"
import script from "./studyMsg.vue?vue&type=script&lang=js"
export * from "./studyMsg.vue?vue&type=script&lang=js"
import style0 from "./studyMsg.vue?vue&type=style&index=0&id=642bdf24&prod&lang=scss"
import style1 from "./studyMsg.vue?vue&type=style&index=1&id=642bdf24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642bdf24",
  null
  
)

export default component.exports